import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9bf1d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-details-card-header-wrapper" }
const _hoisted_2 = { class: "d-flex justify-center mt-n8" }
const _hoisted_3 = { class: "plan-details-card-header align-self-center plan-amount" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"font-weight":"normal","font-size":"35px"},
  class: "pr-1"
}, "₹", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle-2 d-flex justify-center" }, "Details ", -1))
const _hoisted_6 = { class: "plan-details-card-content d-flex justify-center mt-8 mx-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-border-top-left table-right-header" }, " Subscription ", -1))
const _hoisted_8 = {
  class: "color-red",
  style: {"font-weight":"bold"}
}
const _hoisted_9 = {
  key: 2,
  class: "text-left"
}
const _hoisted_10 = {
  key: 3,
  class: "table-border-top-right"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "table-right-header" }, " Speed ", -1))
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = {
  key: 0,
  class: "text-left"
}
const _hoisted_14 = {
  key: 1,
  class: "text-left"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "table-border-bottom-left table-right-header" }, " Data ", -1))
const _hoisted_16 = {
  colspan: "3",
  class: "table-border-bottom-right"
}
const _hoisted_17 = { class: "note ml-6 mt-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Note:", -1))
const _hoisted_19 = { class: "ml-5 mt-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { style: {"font-size":"12px !important"} }, " Commercial usage policy applicable on all Unlimited plans ", -1))
const _hoisted_21 = { style: {"font-size":"12px !important"} }
const _hoisted_22 = { class: "plan-details-card-content d-flex justify-center mt-4 mx-6 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_jt_book_now_button = _resolveComponent("jt-book-now-button")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "plan-details-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card_actions, { class: "d-flex align-end flex-column mt-n2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "primary",
              icon: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closePopup()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  style: {"color":"#ffff"},
                  class: "pa-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(" Plan "),
            _hoisted_4,
            _createTextVNode(_toDisplayString($props.item?.price) + " ", 1),
            _hoisted_5
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_table, null, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                ($props.item?.halfyearly > 0)
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      class: _normalizeClass(["text-left", { 'table-border-top-right': $props.item?.halfyearly == 0 }]),
                      style: _normalizeStyle($props.item?.halfyearly == 0 ? 'width:200px' : '')
                    }, [
                      _createTextVNode(" Monthly "),
                      _withDirectives(_createElementVNode("div", _hoisted_8, "Annual", 512), [
                        [_vShow, $props.item?.title]
                      ])
                    ], 6))
                  : (_openBlock(), _createElementBlock("th", {
                      key: 1,
                      class: _normalizeClass(["text-left", { 'table-border-top-right': $props.item?.halfyearly == 0 }]),
                      style: _normalizeStyle($props.item?.halfyearly == 0 ? 'width:200px' : '')
                    }, " Annual ", 6)),
                ($props.item?.halfyearly > 0)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_9, " Half yearly "))
                  : _createCommentVNode("", true),
                ($props.item?.yearly > 0)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10, " Yearly "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, _toDisplayString($props.item?.speed) + " Mbps ", 1),
                ($props.item?.halfyearly > 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString($props.item?.halfyearly) + " Mbps ", 1))
                  : _createCommentVNode("", true),
                ($props.item?.yearly > 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString($props.item?.yearly) + " Mbps ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", _hoisted_16, _toDisplayString($props.item?.data), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("ul", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("li", _hoisted_21, " GST " + _toDisplayString($props.item?.mode == 1 ? ' Extra' : 'Inclusive'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_jt_book_now_button, {
          onGetBookNowStatus: $setup.getBookNowStatus,
          item: $props.item
        }, null, 8, ["onGetBookNowStatus", "item"])
      ])
    ]),
    _: 1
  }))
}